import styled from 'styled-components';
import { media, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const LinkStatusWrapper = styled(Grid)`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdDown`
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  `}
`;
